import fire from "../../../services/fire";
import {
  EVENT_HUB_BOOK_END,
  EVENT_HUB_BOOK_START,
  EVENT_HUB_DELETE_END,
  EVENT_HUB_DELETE_START,
  logAction,
} from "../../../services/log";
import { getOrgBookingCutoffTimeById } from "../../../services/organisation";
import {
  getWebVersion,
  maxKidAllocationPercent,
  maxNoPETVaccinationCapacity,
} from "../../../services/settings";
import { isChild } from "../../../services/user";
import { callEventHubBooking } from "../services/eventhubooking";
import { getBasicEventDetails } from "./eventHelpers";

export const setEventHubBooking = async (user, event, cb) => {
  //NOTE: this can be placed in sitesettings
  const bookingCutOff = getOrgBookingCutoffTimeById(event.orgId);

  const settings = {
    bookingcutofftime: bookingCutOff, //get from org config
    bookenabled: true, //enable booking
  };
  //NOTE: for now, we won't be using this, but just in case
  const limits = {
    kidpetenabled: false, //no longer required by GOVT
    iskid: isChild(user.dob),
    maxkidcountpercent: maxKidAllocationPercent(),
    petvaccinationlimit: maxNoPETVaccinationCapacity(),
  };
  const basicEventDetails = getBasicEventDetails(event);
  await logAction(user.uid, EVENT_HUB_BOOK_START, {
    limits,
    settings,
    websettings: getWebVersion(),
    event: basicEventDetails,
  });

  const result = await callEventHubBooking(
    user,
    event,
    limits,
    settings,
    getWebVersion()
  );

  await logAction(user.uid, EVENT_HUB_BOOK_END, { result });
  cb(result);
  return result;
};

export const setEventInterest = (eventId, parentEventId, user, cb) => {
  if (eventId && eventId !== "") {
    // Check if entry exists
    fire
      .firestore()
      .collection("eventinterests")
      .where("eventId", "==", eventId)
      .where("createdBy", "==", user.userid)
      .get()
      .then((snapshot) => {
        const now = new Date();
        if (snapshot.empty) {
          // Create new doc
          const newInterestRef = fire
            .firestore()
            .collection("eventinterests")
            .doc();

          newInterestRef.set({
            id: newInterestRef.id,
            parentEventId,
            eventId: eventId,
            interest: true,
            email: user.email,
            mobile: user.mobile,
            dob: user.dob,
            name: user.fullname,
            parish: user.parish,
            createdBy: user.userid,
            lastUpdate: [],
            createdAt: now,
            modifiedAt: now,
          });
          cb();
        } else {
          // update
          const interestObj = snapshot.docs[0].data();
          const interestId = interestObj.id;
          const updateArr = interestObj.lastUpdate;
          updateArr.push({
            interest: true,
            updatedAt: now,
          });
          const interestRef = fire
            .firestore()
            .collection("eventinterests")
            .doc(interestId);
          interestRef
            .update({
              interest: true,
              lastUpdate: updateArr,
              modifiedAt: now,
            })
            .then(() => {
              cb();
            });
        }
      });
  }
};

export const doDeleteEventHubBooking = async (user, eventbooking, cb) => {
  const settings = {
    bookingcutofftime: 1, //get from org config
    bookenabled: true, //enable booking
  };
  //NOTE: for now, we won't be using this, but just in case
  const limits = {
    kidpetenabled: false, //no longer required by GOVT
    iskid: isChild(user.dob),
    maxkidcountpercent: maxKidAllocationPercent(),
    petvaccinationlimit: maxNoPETVaccinationCapacity(),
  };
  const basicEventDetails = getBasicEventDetails(eventbooking);
  await logAction(user.uid, EVENT_HUB_DELETE_START, {
    limits,
    settings,
    websettings: getWebVersion(),
    event: basicEventDetails,
  });

  const result = await callDeleteEventHubBooking(
    user,
    eventbooking,
    limits,
    settings,
    getWebVersion()
  );

  await logAction(user.uid, EVENT_HUB_DELETE_END, { result });
  cb(result);
  return result;
};

export async function callDeleteEventHubBooking(
  user,
  eventbooking,
  limits,
  settings,
  version
) {
  const userObj = {
    parish: user.parish,
    userid: user.userid,
    dob: user.dob,
    mobile: user.mobile,
    email: user.email,
    fullname: user.fullname,
    subid: user.subid,
    identification: user.identification,
  };
  const deleteEventHubBooking = fire
    .functions("asia-east2")
    .httpsCallable("deleteEventHubBooking");
  console.log("Calling deleteEventHubBooking");

  const bookstatus = await deleteEventHubBooking({
    user: userObj,
    event: eventbooking,
    limits: limits,
    settings: settings,
    webversion: version,
  });
  return bookstatus.data;
  //   return { message: `Deleted successfully!`, status: 0 };
}

export function reMapErrorMessage(message) {
  //remap contention errors
  if (message) {
    //aborted?
    if (message.includes("Aborted")) {
      return "Please try again. This transaction cannot be completed at the moment. ";
    }
  }
  return message;
}
